import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { createGridFlight } from "./wave-grid.js";

gsap.registerPlugin(CustomEase);
const arrivalEase = CustomEase.create("about-arrive", "0.16,1,0.3,1");

export function createAboutFlight(dialog, onReverseComplete) {
  const tiles = [...dialog.querySelectorAll(".about-tile")];
  const states = tiles.map(() => ({ progress: 0 }));
  const flight = createGridFlight(tiles, states);
  const timeline = dialog.aboutTimeline = gsap.timeline({ paused: true, onReverseComplete });
  if (flight) dialog.dataset.flight = "true";
  tiles.forEach((tile, index) => {
    const style = getComputedStyle(tile);
    const arrival = style.getPropertyValue("--arrival-delay").trim();
    const delay = 0.54 - parseFloat(arrival) * (arrival.endsWith("ms") ? 0.001 : 1);
    if (flight) {
      tile.style.opacity = "0";
      // WebGL reads progress and updates HTML opacity in the same render pass.
      timeline.to(states[index], { data: tile, progress: 1, duration: 0.7, ease: "none" }, delay);
    } else {
      timeline.fromTo(tile, {
        opacity: 0,
        transform: "perspective(calc(1000 * var(--bento-unit))) translate3d(0, calc(-28 * var(--bento-unit)), calc(-32 * var(--bento-unit))) rotateX(5deg) rotateY(-2deg) scale(0.96)",
      }, {
        data: tile, opacity: 1, transform: "perspective(calc(1000 * var(--bento-unit))) translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg) scale(1)",
        duration: 0.9, ease: arrivalEase,
      }, delay);
    }
  });
  return {
    timeline,
    release() {
      timeline.kill();
      delete dialog.aboutTimeline;
      gsap.set(tiles, { clearProps: "opacity,transform" });
      delete dialog.dataset.flight;
      flight?.release();
    },
  };
}
